import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";


// Get Customer Zone Points Graph
export function getCustomerZonePointsGraph(userId) {
  const request = axios.get(`${urls.Customer_Zone_Points_Graph}?CustomerId=${userId}`);

  return {
    type: ActionTypes.GET_CUSTOMER_ZONE_POINTS_GRAPH,
    payload: request
  };
}

// Get Customer Zone Bar Data
export function getCustomerZoneBarData(userId,zoneId, page, pageSize) {
  return {
    type: ActionTypes.GET_CUSTOMER_ZONE_BAR_DATA,
    payload: axios.get(
      `${urls.Customer_Zone_Bar_Data}?CustomerId=${userId}&ZoneId=${zoneId}&CurrentPage=${page}&PageSize=${pageSize}`
    )
  };
}


export function getCustomerZoneChanges(userId) {
  return {
    type: ActionTypes.GET_CUSTOMER_ZONE_CHANGES,
    payload: axios.get(`${urls.Customer_Zone_Changes_List}?CustomerId=${userId}`)//.then((res) => res.json()),
  };
}

// CustomerZoneModelChange
export function getCustomerZoneModelChange(userId) {
  return {
    type: ActionTypes.GET_CUSTOMER_ZONE_Model_CHANGE,
    payload: axios.get(`${urls.Customer_Zone_Model_Change_List}?CustomerId=${userId}`)//.then((res) => res.json()),
  };
}

//  Get Customer Dashboard header Data
export function getCustomerDashboardData(userId) {
  return {
    type: ActionTypes.GET_CUSTOMER_DASHBOARD_DATA,
    payload: axios.get(`${urls.Customer_Dashboard_Data}?CustomerId=${userId}`)
  };
}

export function getCustomerZoneData(userId) {
  return {
    type: ActionTypes.GET_CUSTOMER_ZONE_DATA,
    payload: axios.get(`${urls.Customer_Zone_Data}?CustomerId=${userId}`)
  };
}
